module.exports = __webpack_public_path__ + "img/26-japan.b8fa88a8.svg";